export default {
  PERMISSION(st) {
    return st.userProfile.permission;
  },

  exportLoginUserProfile(st) {
    return st.userProfile;
  },

  exportMessageBox(st) {
    return st.msgBox;
  },

  exportFastHistoryList(st) {
    return st.fastHistory;
  },

  exportChatGptDescription(st) {
    return st.chatGptAsk;
  },
  notificationList({ notification }) {
    return notification.list
  },
  notificationCount({ notification }) {
    return notification.count
  }
};
